import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-general-error',
    templateUrl: './general-error.component.html',
    styleUrls: ['./general-error.component.scss']
})
export class GeneralErrorComponent implements OnDestroy {
    sub: Subscription;
    messages = [];

    constructor(private route: ActivatedRoute) {
        this.sub = route.queryParams.subscribe(data => {
            console.log('ADTA', data);
            const appError = data['error'] ? JSON.stringify(data['error']) : 'Error';
            const appErrorDescription = data['description'] ? data['description'] : 'Sorry, something went wrong.';
            this.messages = [{ severity: 'error', summary: appError, detail: appErrorDescription }];
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

}
